"use strict";
// Permission system interfaces - mirrors backend constants
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_CODES = exports.ACTIONS = exports.MODULES = void 0;
exports.MODULES = {
    USERS: "users",
    ROLES: "roles",
    ORGANIZATIONS: "organizations",
    CUSTOMERS: "customers",
    PRODUCTS: "products",
    STOCK: "stock",
    ORDERS: "orders",
    DISBURSEMENTS: "disbursements",
    USSD: "ussd",
    REPORTS: "reports",
    AUDIT: "audit",
    SYSTEM: "system",
};
exports.ACTIONS = {
    VIEW: "view",
    CREATE: "create",
    UPDATE: "update",
    DELETE: "delete",
    UPLOAD: "upload",
    AUTHORIZE: "authorize",
    EXPORT: "export",
};
exports.ROLE_CODES = {
    ADMIN: "admin",
    SUPERVISOR: "supervisor",
    ACCOUNTANT: "accountant",
    USER: "user",
};
